window.okeReviewsWidgetOnInit = function () {
  	moveReviewButton();
    const reviewMain = document.querySelector(".js-okeReviews-reviews-main");
    if (reviewMain) {
        const observerConfig = {
            childList: true
        }
        const observer = new MutationObserver(moveReviewsDates)
        observer.observe(reviewMain, observerConfig)
        moveReviewsDates();
        moveRatingSummary();
    }
}

function moveReviewsDates() {
    var reviewDates = document.querySelectorAll(".okeReviews-review-date");
    var reviewSide = document.querySelectorAll(".okeReviews-review-side-inner");
    if (reviewDates.length > 0) {   
        for (var i = 0; i < reviewDates.length; i++) {
            reviewSide[i].insertAdjacentElement('beforeend', reviewDates[i]);
        }
    }
}

function moveRatingSummary() {
    var ratingSummary = document.querySelector(".js-okeReviews-reviewsSummary").cloneNode(true);
    var reviewMainControl = document.querySelector(".okeReviews-reviews-controls");
    if (ratingSummary && reviewMainControl) {
        reviewMainControl.insertAdjacentElement('afterbegin', ratingSummary);
    }
}

function moveReviewButton() {
    var reviewButton = document.querySelector(".js-okeReviews-writeReview.okeReviews-button");
    var destination = document.querySelector(".okeReviews-cta-holder");
    if (reviewButton && destination) {
        destination.insertAdjacentElement('afterbegin', reviewButton);
    }
}